export default __webpack_public_path__ + "bc5c576d1e8e44996d8a457c89341534.png";